module.exports = __webpack_public_path__ + "static/media/Hestia_Logo.1fbc6b54.png";